"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SearchBanner;
var _react = _interopRequireWildcard(require("react"));
var _react2 = require("@linaria/react");
var _core = require("@linaria/core");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _section = _interopRequireDefault(require("@site/pattern-library-core/section"));
var _index = _interopRequireDefault(require("../../elements/other/actions/index"));
var _merchButton = require("@site/pattern-library-core/merch-button");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _siteSearchContext = require("./site-search-context");
var _text = _interopRequireDefault(require("@ux/text"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const BannerCtas = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "BannerCtas",
  class: "pl-blyc4mo"
});
const Arrow = /*#__PURE__*/(0, _react2.styled)("a")({
  name: "Arrow",
  class: "pl-aso6tg2"
});
const Headline = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Headline",
  class: "pl-h1kcwn6c"
});
const headingContainer = "pl-h1o8ionu";
const BannerHeading = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "BannerHeading",
  class: "pl-bs2ulqk"
});
const SearchBannerSection = /*#__PURE__*/(0, _react2.styled)(_section.default)({
  name: "SearchBannerSection",
  class: "pl-skbbmck",
  vars: {
    "skbbmck-0": [({
      alignment
    }) => alignment],
    "skbbmck-3": [({
      alignment
    }) => alignment === 'space-between' ? '1 1 auto' : '0 1 auto']
  }
});

/**
 * Search Banner Component
 * @module SearchBanner
 *
 * @param {Object} props React props
 * @param {string} props._name The component's tracking name
 * @param {boolean} props.invert Invert the color scheme
 * @param {String} props.partial Theme partial
 * @param {string} props.dataCy data-cy attribute value
 * @returns {React.ReactElement} Search Banner Component
 * @public
 */
function SearchBanner({
  _name,
  invert = false,
  partial,
  backgroundColor,
  dataCy = 'search-banner'
}) {
  const {
    searchValue,
    domainSearchUrl,
    searchBanner,
    trackingCustomProperties
  } = (0, _react.useContext)(_siteSearchContext.SiteSearchContext);
  const {
    ctas,
    description,
    layout = 'space-between',
    verticalMargin = 'none'
  } = searchBanner;
  let heading = searchBanner.heading;
  const modifiedCtas = ctas;
  modifiedCtas[0].href = domainSearchUrl;
  modifiedCtas[0].trackingCustomProperties = {
    ...trackingCustomProperties,
    category: 'domains'
  };
  const formatSearchValue = str => {
    const formattedSearchValue = searchValue.replace(/\s/g, '');
    const beforeInd = str.indexOf('{');
    const afterInd = str.indexOf('}');
    if (heading.includes('"')) {
      heading = heading.replace(new RegExp('"', 'g'), ' ');
    }
    return /*#__PURE__*/_react.default.createElement(BannerHeading, {
      "data-cy": "search-value"
    }, heading.substring(0, beforeInd), /*#__PURE__*/_react.default.createElement("span", null, `"${formattedSearchValue}.com"`), heading.substring(afterInd + 2));
  };
  return /*#__PURE__*/_react.default.createElement(SearchBannerSection, {
    dataCy: dataCy,
    _name: _name,
    partial: partial || (invert ? 'dark1' : ''),
    backgroundColor: backgroundColor && (0, _patternLibraryUtils.getBackgroundColor)(backgroundColor),
    alignment: layout,
    textAlign: "start",
    verticalMargin: verticalMargin,
    padding: "small"
  }, /*#__PURE__*/_react.default.createElement(Headline, {
    "data-cy": "headline"
  }, /*#__PURE__*/_react.default.createElement(_text.default.h5, {
    "data-cy": "heading",
    as: "title",
    className: headingContainer
  }, formatSearchValue(heading)), /*#__PURE__*/_react.default.createElement(_text.default.p, {
    as: "paragraph",
    "data-cy": "description"
  }, description)), modifiedCtas && /*#__PURE__*/_react.default.createElement(BannerCtas, {
    "data-cy": "banner-actions"
  }, /*#__PURE__*/_react.default.createElement(_index.default, {
    actionsLayout: "button-set",
    ctas: modifiedCtas
  })), /*#__PURE__*/_react.default.createElement(Arrow, {
    "data-cy": "banner-arrow",
    href: domainSearchUrl
  }, /*#__PURE__*/_react.default.createElement(_patternLibraryUtils.Icon, {
    name: "arrow-right"
  })));
}
SearchBanner.propTypes = {
  _name: _propTypes.default.string,
  dataCy: _propTypes.default.string,
  invert: _propTypes.default.bool,
  partial: _propTypes.default.string,
  backgroundColor: _propTypes.default.oneOfType([_propTypes.default.shape({
    rgb: _propTypes.default.string
  }), _propTypes.default.shape({
    intent: _propTypes.default.string
  })]),
  ctas: _propTypes.default.arrayOf(_propTypes.default.shape(_merchButton.NSMerchButton.propTypes)),
  layout: _propTypes.default.oneOf(['space-between', 'center']),
  searchValue: _propTypes.default.string,
  ..._patternLibraryUtils.marginProps,
  ..._patternLibraryUtils.paddingProps
};